module.exports = __webpack_public_path__ + "img/DrKevinOng.a9edeb5f.png";